import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-tag-select',
    template: `
  <form [formGroup]="tagSelectForm">
  <span style='font-size: 80%; float:right;'><a [routerLink]="" (click)="openTagAddModalDialog()">Add New Tag</a></span>
  <p-autoComplete
  [suggestions]="tagSuggestions"
      [multiple]="true"
      [forceSelection]="false"
      [dropdown]="false"
      [style]="{'width':'100%','padding-bottom':'20px'}"
      [inputStyle]="{'width':'100%'}"
      [minLength]="1"
      formControlName="taskTag"
      unique="true"
      field="name"
      placeholder="Tags"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
  </form>
`,
    styles: [],
    standalone: false
})
export class TagSelectComponent implements OnInit, OnChanges
{
	texts: string[] = [];

	tagSuggestions: string[];

	tagSelectForm: UntypedFormGroup;

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() messageEvent = new EventEmitter<string>();

	@Input() taskId: number;

	@Input() tags;

	@Input() tagType: number;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit()
	{
		this.tagSelectForm = this.formBuilder.group({
			taskTag: [this.tags],
			taskId: [this.taskId]
		});
	}

	// for each letter typed in autocomplete...
	onKeyInput(event)
	{
		let query = event.query;
		this.findTagsWith(query);
		return this.tagSuggestions;
	}

	// not used.
	onKeyUp(event: KeyboardEvent)
	{
		if (event.key === 'Enter')
		{
			let tokenInput = event.srcElement as any;
			console.log('tokenInput ' + JSON.stringify(tokenInput.value));
			if (tokenInput.value)
			{
				this.tagSuggestions.push(tokenInput.value);
				tokenInput.value = '';
			}
		}
	}

	onSelect(event)
	{

		// assemble the payload manually since we are using primeng
		console.log('onSelect: ' + JSON.stringify(event));
		let data: any = {};
		data.taskId = this.taskId;
		data.tagId = event.tagId;
		console.log('onSelect: ' + JSON.stringify(data));
		this.addTaskTag(data);
	}


	onUnselect(event)
	{
		// assemble the payload manually since we are using primeng
		let data: any = {};
		data.taskId = this.taskId;
		data.tagId = event.tagId;
		console.log('onUnselect: ' + JSON.stringify(data));
		this.deleteTaskTag(data);
	}

	findTagsWith(queryString: string)
	{
		this.reportService.findTagsWith(queryString, this.taskId).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.tagSuggestions = [];
				this.tagSuggestions = data.data.tagSummaryList;
				// console.log('QA: ' + JSON.stringify(this.tagSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	addTaskTag(tag)
	{
		this.taskService.addTaskTags(tag).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	deleteTaskTag(tag)
	{
		this.taskService.deleteTaskTag(tag).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	/**
     *
     * method to update parent component
     */

	openTagAddModalDialog()
	{
		{
			this.tagAddModalDialogRef = this.dialog.open(TagAddModalComponent, {
				hasBackdrop: true
			});
			let instance = this.tagAddModalDialogRef.componentInstance;

			// pass the tagType through from the helper to the popup.
			instance.tagType = this.tagType;
		}
	}
	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.tagSelectForm !== undefined)
		{
			this.tagSelectForm.patchValue({ taskId: this.taskId });
		}
	}
}
